const globalEnumPermData = {
    LANG_TYPE: {
        en: '英语',
        pt: '葡萄牙语',
        es: '西班牙语',
    },
}

export default globalEnumPermData
